module.exports = __webpack_public_path__ + "assets/loyalty-promotion-banner.cbfd065e.svg";